import React from "react";
import {
    Navigate,
} from "react-router-dom";

const ControlEventTemplateListComponent = React.lazy(() => import("../../../../../components/control-event-template/components/list/page"));
const ControlEventTemplateAddComponent = React.lazy(() => import("../../../../../components/control-event-template/components/add/page"));

export const controlEventTemplatesRoutes = [
    {
        path: 'list',
        element: <ControlEventTemplateListComponent />
    },
    {
        path: 'add',
        element: <ControlEventTemplateAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/control/event-templates/add" />
    },
    {
        path: 'edit/:id',
        element: <ControlEventTemplateAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/control/event-templates/list" />
    },
];
